// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleCard_root__Fl1av","imageWrapper":"ArticleCard_imageWrapper__FimMm","meta":"ArticleCard_meta__22ng_","link":"ArticleCard_link__pqJkQ"};